import { isStaging } from '@/helpers/environment'

export const defaultPrices = isStaging
  ? [
      { quantity: 1, priceId: 'pri_01k1ggr2y8hwrwvaz3rt53a5dv' },
      { quantity: 1, priceId: 'pri_01k1ggt5bbcp8gtkkcyjasdej6' }
    ]
  : [
      { quantity: 1, priceId: 'pri_01k1g2291zj36ybxgnfyznmk8d' },
      { quantity: 1, priceId: 'pri_01k1g217vxxfs1gk4aaabq2ft9' }
    ]

export const ceoPrices = isStaging
  ? [
      { quantity: 1, priceId: 'pri_01k1ggr2y8hwrwvaz3rt53a5dv' },
      { quantity: 1, priceId: 'pri_01k1ggt5bbcp8gtkkcyjasdej6' }
    ]
  : [
      { quantity: 1, priceId: 'pri_01k1g2291zj36ybxgnfyznmk8d' },
      { quantity: 1, priceId: 'pri_01k1g217vxxfs1gk4aaabq2ft9' }
    ]
